export const SOUNDS = {
  menu_button_click: 'menu_button_click',

  side_menu_click: 'side_menu_click',
  visual_toggle_click: 'visual_toggle_click',
  visual_toggles_expand: 'visual_toggles_expand',

  game_start: 'game_start',

  undo_click: 'undo_click',
  initiative: 'initiative',

  token_click_common: 'token_click_common',
  token_click_page: 'token_click_page',
  token_click_special: 'token_click_special',
  token_click_unit: 'token_click_unit',

  turn_end: 'turn_end',
  turn_stage_end: 'turn_stage_end',
  timer: 'timer',

  phase_supply: 'phase_supply',
  phase_construction: 'phase_construction',
  phase_war: 'phase_war',

  starting_quarter: 'starting_quarter',

  select_farm_1: 'select_farm_1',
  select_farm_2: 'select_farm_2',
  select_farm_3: 'select_farm_3',
  select_farm_4: 'select_farm_4',
  select_farm_5: 'select_farm_5',
  select_farm_6: 'select_farm_6',
  select_farm_7: 'select_farm_7',

  distribute_supply: 'distribute_supply',

  build_road: 'build_road',
  build_common: 'build_common',
  build_hammers: 'build_hammers',
  build_central_quarter: 'build_central_quarter',
  build_special: 'build_special',
  build_fortress: 'build_fortress',

  special_building_palace: 'special_building_palace',
  special_building_military_camp: 'special_building_military_camp',
  special_building_arsenal: 'special_building_arsenal',
  special_building_temple: 'special_building_temple',
  special_building_guild: 'special_building_guild',
  special_building_warehouse_1: 'special_building_warehouse_1',
  special_building_warehouse_2: 'special_building_warehouse_2',

  // Город получил руины (рудник звучит звуком разведки гномов)
  ruins_capture: 'ruins_capture',
  super_ruins_capture: 'super_ruins_capture',

  coins_1_1: 'coins_1_1',
  coins_1_2: 'coins_1_2',
  coins_1_3: 'coins_1_3',
  coins_2_1: 'coins_2_1',
  coins_2_2: 'coins_2_2',
  coins_2_3: 'coins_2_3',
  coins_3_1: 'coins_3_1',
  coins_3_2: 'coins_3_2',
  coins_3_3: 'coins_3_3',
  coins_some_1: 'coins_some_1',
  coins_some_2: 'coins_some_2',
  coins_some_3: 'coins_some_3',
  coins_many_1: 'coins_many_1',
  coins_many_2: 'coins_many_2',
  coins_many_3: 'coins_many_3',

  select_unit_d6: 'select_unit_d6',
  select_unit_d10: 'select_unit_d10',
  select_unit_d20: 'select_unit_d20',
  select_unit_d8: 'select_unit_d8',
  select_unit_d12: 'select_unit_d12',
  select_unit_d4: 'select_unit_d4',
  select_unit_enemy: 'select_unit_enemy',

  unit_upgrade: 'unit_upgrade',

  move_d6: 'move_d6',
  move_d10: 'move_d10',
  move_d20: 'move_d20',
  move_d8: 'move_d8',
  move_d12: 'move_d12',
  move_d4: 'move_d4',

  alert_info: 'alert_info',
  alert_error: 'alert_error',

  shooting_d4: 'shooting_d4',
  shooting_d4_impact: 'shooting_d4_impact',
  shooting_impact_cry_1: 'shooting_impact_cry_1',

  battle_1: 'battle_1',
  battle_2: 'battle_2',
  // Взмах оружия в анимации удара ближнего боя: чем сильнее удар, тем
  // тяжелее звук (см. MELEE_STRIKE_SOUNDS в configs/meleeAnimation)
  sward_flash_1: 'sward_flash_1',
  sward_flash_2: 'sward_flash_2',
  sward_flash_3: 'sward_flash_3',
  sward_flash_4: 'sward_flash_4',

  select_dice_melee: 'select_dice_melee',
  select_dice_shooting_d4: 'select_dice_shooting_d4',
  dice_1_1: 'dice_1_1',
  dice_1_2: 'dice_1_2',
  dice_1_3: 'dice_1_3',
  dice_1_4: 'dice_1_4',
  dice_2_1: 'dice_2_1',
  dice_2_2: 'dice_2_2',
  dice_2_3: 'dice_2_3',
  dice_2_4: 'dice_2_4',
  reroll_bad_luck: 'reroll_bad_luck',
  priority_target_select: 'priority_target_select',

  modal_combat_results: 'modal_combat_results',
  agony_1: 'agony_1',
  agony_2: 'agony_2',
  modal_city_capture: 'modal_city_capture',
  modal_round_end: 'modal_round_end',

  birds: 'birds',

  policy_buy: 'policy_buy',
  policy_market_clear: 'policy_market_clear',
  card_open: 'card_open',

  // FACTIONS
  leprechauns_coins: 'leprechauns_coins',
  leprechauns_laugh: 'leprechauns_laugh',

  dwarves_mine_exploration_1: 'dwarves_mine_exploration_1',
  dwarves_mine_exploration_2: 'dwarves_mine_exploration_2',

  elves_shooting: 'elves_shooting',
  elves_shooting_agony: 'elves_shooting_agony',

  trap_set: 'trap_set',
  trap_trigger: 'trap_trigger',
}